
























































































































import axios from 'axios';
import i18n from 'vue-i18n';
import { get, over } from 'lodash';
import EventBus from '@/eventBus';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import EventList from '@/components/Templates/User/Event/List/ListEvents.vue';
import CoLabel from '@/components/Atoms/co-label/CoLabel.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoEditor from '@/components/Molecules/co-editor/CoEditor.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoSharableInput from '@/components/Organisms/co-copy-sharable-input/CoSharableInput.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';

export default {
    name: 'MemberEventList',
    i18n: {
        messages: {
            en: {
                createeventspermissiontitlte: 'Who is allowed to create events?',
                everyone: 'Everyone',
                adminsonly: 'Admins',
                permissionsupdated: 'Permissions updated',
                permissionsupdatefailed: 'Failed to update permissions',
                shareevents: 'Share public events',
                publiceventlist: 'Public event list',
                embedpubliceventlist: 'Embed event list',
                embedcodeinfo: 'Copy this HTML code and paste it into your website',
            },
            de: {
                createeventspermissiontitlte: 'Wer darf Veranstaltungen erstellen?',
                everyone: 'Jede:r',
                permissionsupdated: 'Berechtigungen aktualisiert',
                permissionsupdatefailed: 'Fehler beim Aktualisieren der Berechtigungen',
                shareevents: 'Veranstaltungen teilen',
                publiceventlist: 'Öffentliche Übersicht',
                embedpubliceventlist: 'Übersicht einbetten',
                embedcodeinfo: 'Kopiere diesen HTML-Code und füge ihn in deine Webseite ein',
            },
        },
    },
    components: {
        CoButton,
        CoIcon,
        CoHeadline,
        CoCard,
        CoRoundButton,
        EventList,
        CoLabel,
        CoLink,
        CoModal,
        CoEditor,
        CoDropdown,
        CoDropdownItem,
        CoCheckbox,
        CoFormGroup,
        CoSharableInput,
        CoAlert,
    },
    data() {
        return {
            isAdmin: this.$store?.state?.me?.Permissions && this.$store.state.me.Permissions.includes('space_admin'),
            showEventSettings: false,
            permissions: {
                EventsCreateAdminsOnly: false,
            },
            permissionsLoading: false,
            embedCode: `<iframe src="${window.location.origin}/embed/events" width="100%" height="100%" frameborder="0"></iframe>`,
        };
    },
    computed: {
        isUserAllowedToCreateEvent() {
            return this.isAdmin || !this.$store?.state?.permissions?.EventsCreateAdminsOnly;
        },
    },
    mounted() {
        if (this.isAdmin) {
            this.getPermissions();
        }
    },
    methods: {
        showEmbedModal() {
            this.$refs.embedmodal.show();
        },
        copyValueToClipboard(value) {
            navigator.clipboard.writeText(value);
            EventBus.$emit('INFO', {
                Message: this.$t('messages.copiedtoclipboard'),
                Details: '',
            });
        },
        getPermissions() {
            this.permissionsLoading = true;
            axios
                .get('/admin/space/permissions')
                .then((response: any) => {
                    this.permissions = {
                        EventsCreateAdminsOnly: get(response, 'data.EventsCreateAdminsOnly', false),
                    };
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    this.permissionsLoading = false;
                });
        },
        setPermissions() {
            this.permissionsLoading = true;
            axios
                .post('/admin/space/permissions', this.permissions)
                .then((response: any) => {
                    EventBus.$emit('INFO', {
                        Message: this.$t('permissionsupdated'),
                    });
                })
                .catch((error: any) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('permissionsupdatefailed'),
                    });
                    console.log(error);
                })
                .finally(() => {
                    this.permissionsLoading = false;
                });
        },
    },
};
